// import { BASE_URL } from '@/api/url';
// import BaseFuncApi from '@/api/base/commonFunc-api';
// import Enum from '@/enum/enum';
import AuthClient from "@/api/auth/auth-client";
const authClient = new AuthClient();
export default {
  /**
     * 
     * @param {*} context 
     * @param {*} payload 
     * @returns 
    * {
    "access_token": "string",
    "expires_in": 0,
    "id_token": "string",
    "refresh_token": "string",
    "token_type": "string"
}
     */
  LoginWithLocal: async function (context, payload) {
    var result = await authClient.postAsync(
      {
        url: `${authClient.url}/login-with-local`,
        data: payload,
      },
      true
    );
    if (result && result.access_token) {
      return result;
    }
    return null;
  },

  logOutUser: async function (context, payload) {
    const keyJwt = "Jwt";
    const resToken = localStorage.getItem(keyJwt);
    var result = await authClient.postAsync(
      {
        url: `${authClient.url}/me/logout`,
        data: payload,
        headers: {
          Authorization: `Bearer ${resToken}`,
        },
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  changePassword: async function (context, payload) {
    var result = await authClient.patchAsync(
      {
        url: `${authClient.url}/me/password`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  getMyProfile: async function (context, payload) {
    const keyJwt = "Jwt";
    const resToken = localStorage.getItem(keyJwt);
    var result = await authClient.getAsync(
      {
        url: `${authClient.url}/me/profile`,
        data: payload,
        headers: {
          Authorization: `Bearer ${resToken}`,
        },
      },
      true
    );
    if (result && result.data) {
      context.commit("updateUserProfile", result.data);
      return result.data;
    }
    return null;
  },
  refreshToken: async function (context, payload) {
    var result = await authClient.postAsync(
      {
        url: `${authClient.url}/refresh-token`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  changeMyPassword: async function (context, payload) {
    var result = await authClient.patchAsync(
      {
        url: `${authClient.url}/user/${payload.id}/reset-password`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  updateNewPassword: async function (context, payload) {
    var result = await authClient.patchAsync(
      {
        url: `${authClient.url}/users/update-password`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  getStatisticInfo: async function (context, payload) {
    const keyJwt = "Jwt";
    const resToken = localStorage.getItem(keyJwt);
    var result = await authClient.getAsync(
      {
        url: `${authClient.url}/statistic`,
        data: payload,
        headers: {
          Authorization: `Bearer ${resToken}`,
        },
      },
      true
    );

    let res = {};
    if (result && result.data) {
      res = result.data;
    } else {
      res = {
        product: 0,
        odPlace: 0,
        odProcessing: 0,
        odShipped: 0,
        odDelivered: 0,
        odCancelled: 0,
        customer: 0,
      };
    }
    context.commit("updateStatisticInfo", res);
    return res;
  },

  getResources: async function (context, payload) {
    const keyJwt = "Jwt";
    const resToken = localStorage.getItem(keyJwt);
    var result = await authClient.getAsync(
      {
        url: `${authClient.url}/resource-scopes`,
        headers: {
          Authorization: `Bearer ${resToken}`,
        },
      },
      true
    );
    if (result && result.data) {
      context.commit("updateResources", result.data);
      return result.data;
    }
    return null;
  },

  getPolicy: async function (context, payload) {
    const keyJwt = "Jwt";
    const resToken = localStorage.getItem(keyJwt);
    var result = await authClient.getAsync(
      {
        url: `${authClient.url}/policies/${payload.policyId}`,
        headers: {
          Authorization: `Bearer ${resToken}`,
        },
      },
      true
    );
    if (result && result.data) {
      return result.data;
    }
    return null;
  },

  createPolicy: async function (context, payload) {
    const keyJwt = "Jwt";
    const resToken = localStorage.getItem(keyJwt);
    var result = await authClient.postAsync(
      {
        url: `${authClient.url}/policies`,
        headers: {
          Authorization: `Bearer ${resToken}`,
        },
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  updatePolicy: async function (context, payload) {
    const keyJwt = "Jwt";
    const resToken = localStorage.getItem(keyJwt);
    var result = await authClient.putAsync(
      {
        url: `${authClient.url}/policies/${payload.policyId}`,
        data: payload,
        headers: {
          Authorization: `Bearer ${resToken}`,
        },
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },
};
